import React, { useEffect, useState } from "react";
import api from "../../api/axios.tsx"; // Make sure to install axios if you haven't already
import { useNavigate, Link } from "react-router-dom";
import Button from "../../components/ui/button.tsx";
import Input from "../../components/ui/input.tsx";
import Label from "../../components/ui/label.tsx";
import { GoogleLogin } from "@react-oauth/google";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // get user from localstorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      // If user exists, redirect to dashboard
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    api
      .post("/auth/login", { email, password })
      .then((response) => {
        // const { access_token, ...user } = response.data;

        // Store the token
        // localStorage.setItem("token", access_token);
        localStorage.setItem("user", JSON.stringify(response.data));

        // Redirect user to dashboard or another route
        navigate("/dashboard");
      })
      .catch((error) => {
        console.error("Login failed:", error);
        // Show error to user if needed
      });
  };

  const onSuccess = (response) => {
    const idToken = response.credential;

    api
      .post(
        "/auth/google/token",
        {
          id_token: idToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const data = response.data;

        if (data) {
          localStorage.setItem("user", JSON.stringify(data));
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        console.error("Backend Google login verification failed:", error);
      });
  };

  const onError = () => {
    console.error("Login Failed");
  };

  return (
    <div className="page flex items-center justify-center p-4">
      <div className="w-full max-w-md p-8 card-glass relative z-10">
        <div className="text-center">
          <div className="eyebrow inline-block mb-4">Sign in</div>
          <h1 className="heading-2 text-center text-glow">Welcome back</h1>
          <p className="subheading">
            Access your dashboard and keep finances on track.
          </p>
        </div>
        <form className="flex flex-col mt-6" onSubmit={handleSubmit}>
          <Label htmlFor="email" className="mb-1">
            Email
          </Label>
          <Input
            id="email"
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mb-4"
          />
          <Label htmlFor="password" className="mb-1">
            Password
          </Label>
          <Input
            id="password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mb-2"
          />
          <Button
            type="submit"
            className="mt-4 btn-primary w-full"
            variant="default"
          >
            Login
          </Button>
        </form>
        <div className="mt-6 flex items-center gap-3">
          <div className="h-px bg-white/15 w-full" />
          <span className="text-xs text-white/70 text-nowrap">Or</span>
          <div className="h-px bg-white/15 w-full" />
        </div>
        <div className="mt-4 flex flex-col gap-3">
          <GoogleLogin
            onSuccess={onSuccess}
            onError={onError}
            theme="filled_black"
            size="large"
            text="continue_with"
            shape="pill"
            width="360"
          />
        </div>
        <div className="mt-6 text-center text-sm text-gray-400">
          <p>
            Don't have an account?{" "}
            <Link className="text-blue-400 hover:underline" to="/auth">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
